const BookActionTypes = Object.freeze({
  read: 'READ',
  listen: 'LISTEN',
  record: 'RECORD',
  quiz: 'QUIZ',
  material: 'MATERIAL',
});

export default BookActionTypes;
